<template>
  <div class="haircut row align-items-center m-auto">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <div class="border-div">
              <div class="token-head">Your Token Number Is:</div>
              <div class="token-number">{{ this.$route.params.token }}</div>
            </div>

            <div class="see-you-text">
              See You <i class="fa fa-smile-o"></i>
            </div>
            <div class="cont-btn">
              <router-link to="/" class="btn btn-primary">Continue</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TokenPage",
  props: ["token_number"],
  mounted() {
    console.log(this.token_number);
    setTimeout(this.goToHome, 5000)
    // this.goToHome();
  },
  methods: {
    goToHome() {
      this.$router.push("/");
    },
  },
};
</script>
